"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var ExpressionsOfInterest_1 = require("../../../../commonSteps/extras/components/expressionsOfInterest/ExpressionsOfInterest");
var useCheckoutContext_1 = require("../../../../common/hooks/useCheckoutContext");
var Loader_1 = require("../../../../../common/components/presentation/Loader/Loader");
var extrasStyles_1 = require("./extrasStyles");
var Routes_1 = require("../../../../../common/enum/Routes");
var react_router_1 = require("react-router");
var collectedFilters_1 = require("../../../../../common/service/collectedFilters");
var useSaveExpressionsOfInterest_1 = require("../../../../commonSteps/extras/hooks/mutations/useSaveExpressionsOfInterest");
var useJourneyStepsContext_1 = require("../../../hooks/useJourneyStepsContext");
var ContinueButton_1 = require("../../buttons/continueButton/ContinueButton");
var Extras = function () {
    var _a;
    var styles = extrasStyles_1.default();
    var history = react_router_1.useHistory();
    var handleNext = useJourneyStepsContext_1.default().handleNext;
    var saveExpressionsOfInterest = useSaveExpressionsOfInterest_1.useSaveExpressionsOfInterest().saveExpressionsOfInterest;
    var _b = useCheckoutContext_1.default(), deal = _b.deal, loading = _b.loading, error = _b.error, refetch = _b.refetch;
    var _c = react_1.useState([]), dealExpressionsOfInterest = _c[0], setDealExpressionsOfInterest = _c[1];
    var postCode = (((_a = deal) === null || _a === void 0 ? void 0 : _a.dealer) || {}).postCode;
    var _d = collectedFilters_1.default().filters, token = _d.token, expressionsOfInterest = _d.expressionsOfInterest;
    react_1.useEffect(function () {
        var _a;
        setDealExpressionsOfInterest(((_a = deal) === null || _a === void 0 ? void 0 : _a.expressionsOfInterest) ? deal.expressionsOfInterest.map(function (item) { return item.code; }) : []);
    }, [deal]);
    var goToNextStep = react_1.useCallback(function () { return handleNext(); }, [handleNext]);
    var redirectUnavailableDeal = react_1.useCallback(function () { return history.replace(Routes_1.Routes.DEAL_UNAVAILABLE, {}); }, []);
    var clickContinueCTA = react_1.useCallback(function () {
        var _a, _b;
        var codes = (_b = (_a = expressionsOfInterest) === null || _a === void 0 ? void 0 : _a.split(','), (_b !== null && _b !== void 0 ? _b : []));
        saveExpressionsOfInterest(token, codes)
            .then(function () {
            setDealExpressionsOfInterest(codes);
            refetch();
            goToNextStep && goToNextStep();
        })
            .catch(function () {
            history.push({ pathname: Routes_1.Routes.DEAL_UNAVAILABLE });
        });
    }, [history, token, postCode, expressionsOfInterest, dealExpressionsOfInterest]);
    react_1.useEffect(function () {
        if (error) {
            redirectUnavailableDeal();
        }
    }, [error]);
    if (loading) {
        return <Loader_1.default />;
    }
    return (<>
      <core_1.Box className={styles.container} data-test={'checkout4:extras:root'}>
        <ExpressionsOfInterest_1.default dealExpressionsOfInterest={dealExpressionsOfInterest}/>
      </core_1.Box>
      <core_1.Box className={styles.actionButtonContainer}>
        <ContinueButton_1.default testId="checkout4:continue_button:extras" handleClick={clickContinueCTA} activateNextStep={false}/>
      </core_1.Box>
    </>);
};
exports.default = Extras;
